import store from "../../store";

export const updateAddComponentinToolbarAction = payload => dispatch => {
  dispatch({
    type: "UPDATE_ADD_COMPONENT_TYPE",
    payload,
  });

  if (payload === "HeaderFooter") {
    dispatch({
      type: "UPDATE_TOOLPANE_DATA",
      payload: {
        view: "doc-components",
        isOpen: true,
      },
    });
  }
};

export const updateToolpaneViewTypeSignProperties =
  (view, isOpen, component_id) => dispatch => {
    dispatch({
      type: "UPDATE_TOOLPANE_DATA_FOR_SIGN_PROP",
      payload: {
        isOpen,
        view,
        component_id,
      },
    });
  };

export const updateToolpaneView =
  (section, page = "DOCUMENT") =>
  dispatch => {
    const isSignature = section && section.type === "Signature";
    const isPayment = section && section.type === "StripePayment";
    const reduxState = store.getState();
    const { addComponentType, isOpen, view } = reduxState.ToolPaneStore;
    let newView = "";
    if (
      (isSignature && view !== "doc-components") ||
      (isPayment && view !== "doc-components")
    ) {
      newView = "doc-components";
    }
    if (
      !isOpen ||
      (isOpen && isSignature && view !== "doc-components") ||
      (isOpen && isPayment && view !== "doc-components")
    ) {
      dispatch({
        type: "UPDATE_TOOLPANE_DATA",
        payload: {
          view: newView === "" ? view : newView,
          page,
          isOpen: true,
        },
      });
    }

    // Decide the "addComponentType"
    let componentType = null;
    // Case 1: If Clicked on Signature Block Section
    if (section && isSignature) {
      componentType = "Signature";
    }
    // Case 2: If Clicked on Stripe Payment Block Section
    else if (section && isPayment) {
      componentType = "StripePayment";
    }
    // Case 3: If Hover or Clicked on text section & current addComponentType === "Signature"
    else if (
      addComponentType === "Signature" ||
      addComponentType === "StripePayment"
    ) {
      componentType = null;
    }
    // Case 4: If not both above cases
    else {
      componentType = addComponentType;
    }

    if (isSignature || isPayment) {
      store.dispatch(updateAddComponentinToolbarAction(componentType));
    } else if (
      !isOpen ||
      (isOpen &&
        (addComponentType === "Signature" || view !== "doc-components"))
    ) {
      store.dispatch(updateAddComponentinToolbarAction(componentType));
    } else if (
      !isOpen ||
      (isOpen &&
        (addComponentType === "StripePayment" || view !== "doc-components"))
    ) {
      store.dispatch(updateAddComponentinToolbarAction(componentType));
    }
  };
